var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferralBrush(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H54C57.3 6 60 8.7 60 12V24.96H12V12C12 8.7 14.7 6 18 6Z",
    fill: "#437ADB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 24.96V35.64C12 38.88 13.7401 41.8799 16.5901 43.4699L25.47 48.4799C27.36 49.5299 28.53 51.5399 28.53 53.6999V59.9999C28.53 63.2999 31.23 65.9999 34.53 65.9999H37.53C40.83 65.9999 43.53 63.2999 43.53 59.9999V53.6999C43.53 51.5399 44.7001 49.5299 46.5901 48.4799L55.47 43.4699C58.29 41.8799 60.0601 38.88 60.0601 35.64V24.96H12Z",
    fill: "#C7D7F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralBrush);
export default __webpack_public_path__ + "static/media/referral-brush.07db29e39e699e00c779a9832058b3c4.svg";
export { ForwardRef as ReactComponent };